<template>
  <b-badge v-if="isInactive" variant="danger" class="mr-1">Inactive</b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
  name: "InactiveIcon",
  components: { BBadge },
  props: {
    item: { type: Object, required: true },
  },
  computed: {
    isInactive() {
      return (
        this.item.active_end_date &&
        new Date(this.item.active_end_date) <= new Date()
      );
    },
  },
};
</script>
